module.exports = __webpack_public_path__ + "media/confirm_style_1_echo_002.21a95020.mp3";